import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { QrCodeModule } from 'ng-qrcode';

import { WarehousingRoutingModule } from './warehousing-routing.module';
import { CoreModule } from '../core/core.module';
import { WarehousesComponent } from './pages/warehouses/warehouses.component';
import { WarehousesNewComponent } from './pages/warehouses-new/warehouses-new.component';
import { WarehousesEditComponent } from './pages/warehouses-edit/warehouses-edit.component';
import { WarehouseFormComponent } from './partials/warehouse-form/warehouse-form.component';
import { StorageRatesComponent } from './pages/storage-rates/storage-rates.component';
import { StorageChargesComponent } from './pages/storage-charges/storage-charges.component';
import { StorageRatesNewComponent } from './pages/storage-rates-new/storage-rates-new.component';
import { StorageRatesEditComponent } from './pages/storage-rates-edit/storage-rates-edit.component';
import { StorageRateFormComponent } from './partials/storage-rate-form/storage-rate-form.component';
import { LocationsComponent } from './pages/locations/locations.component';
import { LocationsNewComponent } from './pages/locations-new/locations-new.component';
import { LocationsEditComponent } from './pages/locations-edit/locations-edit.component';
import { WarehouseLocationFormComponent } from './partials/warehouse-location-form/warehouse-location-form.component';
import { ProductGroupsComponent } from './pages/product-groups/product-groups.component';
import { ProductGroupsNewComponent } from './pages/product-groups-new/product-groups-new.component';
import { ProductGroupsEditComponent } from './pages/product-groups-edit/product-groups-edit.component';
import { ProductGroupFormComponent } from './partials/product-group-form/product-group-form.component';
import { ProductClassesComponent } from './pages/product-classes/product-classes.component';
import { ProductClassesNewComponent } from './pages/product-classes-new/product-classes-new.component';
import { ProductClassesEditComponent } from './pages/product-classes-edit/product-classes-edit.component';
import { ProductClassFormComponent } from './partials/product-class-form/product-class-form.component';
import { StockLevelsComponent } from './pages/stock-levels/stock-levels.component';
import { StockMovementsComponent } from './pages/stock-movements/stock-movements.component';
import { GoodsInComponent } from './pages/goods-in/goods-in.component';
import { GoodsOutComponent } from './pages/goods-out/goods-out.component';
import { StockAdjustmentComponent } from './pages/stock-adjustment/stock-adjustment.component';
import { StockTransferComponent } from './pages/stock-transfer/stock-transfer.component';
import { StockOperationFormComponent } from './partials/stock-operation-form/stock-operation-form.component';
import { LocationsLabelsComponent } from './pages/locations-labels/locations-labels.component';
import { LocationsLabelComponent } from './pages/locations-label/locations-label.component';
import { ProductsLabelComponent } from './pages/products-label/products-label.component';
import { StockLabelComponent } from './partials/stock-label/stock-label.component';
import { LabelPrintSetupComponent } from './partials/label-print-setup/label-print-setup.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { ReportStockOnHandComponent } from './pages/report-stock-on-hand/report-stock-on-hand.component';
import { ReportMovementHistoryComponent } from './pages/report-movement-history/report-movement-history.component';
import { ReportAdjustmentsComponent } from './pages/report-adjustments/report-adjustments.component';
import { ReportReconciliationComponent } from './pages/report-reconciliation/report-reconciliation.component';
import { ReportBatchTraceabilityComponent } from './pages/report-batch-traceability/report-batch-traceability.component';
import { ReportSlowMovingComponent } from './pages/report-slow-moving/report-slow-moving.component';
import { CostHistoryComponent } from './pages/cost-history/cost-history.component';
import { StockRevaluationComponent } from './pages/stock-revaluation/stock-revaluation.component';
import { AssistantComponent } from './pages/assistant/assistant.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { WarehousingChartsComponent } from './partials/warehousing-charts/warehousing-charts.component';
import { AssistantLauncherComponent } from './partials/assistant-launcher/assistant-launcher.component';
import { StockMovementLabelsComponent } from './pages/stock-movement-labels/stock-movement-labels.component';


@NgModule({
  declarations: [
    WarehousesComponent,
    WarehousesNewComponent,
    WarehousesEditComponent,
    WarehouseFormComponent,
    StorageRatesComponent,
    StorageChargesComponent,
    StorageRatesNewComponent,
    StorageRatesEditComponent,
    StorageRateFormComponent,
    LocationsComponent,
    LocationsNewComponent,
    LocationsEditComponent,
    WarehouseLocationFormComponent,
    ProductGroupsComponent,
    ProductGroupsNewComponent,
    ProductGroupsEditComponent,
    ProductGroupFormComponent,
    ProductClassesComponent,
    ProductClassesNewComponent,
    ProductClassesEditComponent,
    ProductClassFormComponent,
    StockLevelsComponent,
    StockMovementsComponent,
    GoodsInComponent,
    GoodsOutComponent,
    StockAdjustmentComponent,
    StockTransferComponent,
    StockOperationFormComponent,
    LocationsLabelsComponent,
    LocationsLabelComponent,
    ProductsLabelComponent,
    StockLabelComponent,
    LabelPrintSetupComponent,
    DashboardComponent,
    ReportsComponent,
    ReportStockOnHandComponent,
    ReportMovementHistoryComponent,
    ReportAdjustmentsComponent,
    ReportReconciliationComponent,
    ReportBatchTraceabilityComponent,
    ReportSlowMovingComponent,
    CostHistoryComponent,
    StockRevaluationComponent,
    AssistantComponent,
    WarehousingChartsComponent,
    AssistantLauncherComponent,
    StockMovementLabelsComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    // CoreModule imports QrCodeModule without re-exporting it, so <qr-code> needs it here too.
    QrCodeModule,
    NgxChartsModule,
    WarehousingRoutingModule
  ],
  exports: [
    // AppComponent uses this to mount the assistant globally as a floating launcher
    // (see app.component.html) — it needs AssistantComponent too since the launcher's
    // own template embeds <app-assistant [compact]="true">.
    AssistantLauncherComponent,
    AssistantComponent
  ]
})
export class WarehousingModule { }
